import {
  Component,
  EventEmitter, HostBinding,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges, TemplateRef,
  ViewChild,
  DoCheck
} from '@angular/core';
import {CdkDrag, CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {NzModalService} from "ng-zorro-antd/modal";
import * as _ from 'lodash';
import {NgxXLSXService} from "@notadd/ngx-xlsx";
import * as XLSX from 'xlsx';
import * as moment from 'moment';
import * as FileSaver from 'file-saver';
import {NzNotificationService} from "ng-zorro-antd/notification";
import {NzTableFilterFn, NzTableFilterList, NzTableQueryParams, NzTableSortFn} from "ng-zorro-antd/table";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SysDataModelFieldService} from "../../../services/system/sys-data-model-field.service";
import {SysUiDisplayService} from "../../../services/system/sys-ui-display.service";
import {PermissionToolkitService} from "../../../services/permission-toolkit.service";
import {TagService} from "../../../services/tag/tag.service";
import {StorageService} from "../../../services/storage.service";
import {NzContextMenuService, NzDropdownMenuComponent} from "ng-zorro-antd/dropdown";
import {TranslateService} from "@ngx-translate/core";
import {NzTableLayout} from "ng-zorro-antd/table/src/table.types";
import {DatePipe} from "@angular/common";
import {TagCategoryService} from "../../../services/tag/tag-category.service";

export class SysDataModelField {
  id: any;
  fieldDataType: string;
  fieldName: string;
  fieldPropertyName: string;
  fieldDisplayName: string;
  fieldStatus: string;
  fieldType: string;
  dataModelId: any;
  description: string;
  displayOrder: number;
  displayed: boolean;
  isDisplayField: boolean;
  searchAble: boolean;
  sortAble: boolean;
  filterAble: boolean;
  filterVisible: boolean;
  filterSelected: any[];
  editAble: boolean;
  dataFormat: string;
  outputDataFormat: string;
  dataEllipsis: boolean;
  valueMapData: any;
  clickable: boolean;
  nzLeft: boolean;
  nzRight: boolean;
  nzWidth: number;
  alias: any;

  constructor(initObj?: any) {
    if (initObj) {
      for (var prop in initObj) {
        this[prop] = initObj[prop];
      }
    }
  }
}

@Component({
  selector: 'pi-data-table',
  templateUrl: './pi-data-table.component.html',
  styleUrls: ['./pi-data-table.component.css'],
  providers: [NgxXLSXService, DatePipe]
})
// DoCheck
export class PiDataTableComponent implements OnInit, OnChanges {
  @ViewChild('columnSettingsTpl') columnSettingsTpl;
  @ViewChild('mainTable') mainTable;
  @ViewChild('dataProcessorContent') dataProcessorContent;
  @ViewChild('dataProcessorFooter') dataProcessorFooter;
  @ViewChild('dataProcessorModal') dataProcessorModal;
  @Input() componentSize: 'middle' | 'small' | 'default' = 'small';
  @Input() showQuickSearch: boolean = true;
  @Input() showColumnConfigBtn: boolean = true;
  @Input() showExportBtn: boolean = true;
  @Input() showToolBtn: boolean = false;
  @Input() showDataProcessorBtn: boolean = true;
  @Input() useDataProcessor: boolean = true;
  @Input() showIndexCount: boolean = true;
  @Input() indexCountNzWidth = 8;
  @Input() privilegeControl: boolean = true;
  @Input() toolBtnPrivilegeCode: string = 'TOOLBTN';
  @Input() businessType;
  @Input() data: any[] = [];
  @Input() dataModelId: any;
  @Input() columnSettings: SysDataModelField[];
  @Input() pickedColumnSettings: SysDataModelField[] = [];
  @Input() showTableBorder = true;
  @Input() columnPickable = true;
  @Input() tagCategory: string | any[];
  @Input() aggregateTag = false;
  @Input() buttonAreaTemplate;
  @Input() tableTitle;
  @Input() viewMode: 'pagination' | 'scroll' = 'pagination';
  @Input() pageCode = 'default';
  @Input() pageName = 'default';
  @Input() configType = 'default';
  @Input() pageSize: number = this.viewMode === 'pagination' ? 9999999 : 20;
  @Input() pageIndex: number = 1;
  @Input() total: number = null;
  @Input() scrollConfig: string = 'calc(100vh - 200px)';
  @Input() paginationScrollConfig;
  @Input() useScrollX: boolean = false;
  @Input() showExpand = false;
  @Input() showExpandNzWidth = 30;
  @Input() showExpandNzRight = false;
  @Input() isLoading = false;
  @Input() expandTemplate;
  @Input() extraHeaderColumn;
  @Input() extraDataColumn;
  @Input() extraTdWidth: number = 120;
  @Input() searchBoxWidth: number = 300;
  @Input() setExtraTdFixed: boolean = false;
  @Input() exportFileName = '文件导出';
  @Input() selectable: boolean = false;
  @Input() selectableNzWidth = 30;
  @Input() selectableNzRight = false;
  @Input() setOfDisabledCheckedId = new Set<any>();
  @Input() allCheckDisabled: boolean = false;
  @Input() allChecked: boolean = false;
  @Input() defaultCheckAll: boolean = false;
  @Input() isFrontPagination: boolean = true;
  @Input() showPopupMenu: boolean = false;
  @Input() popupMenuTemplate: TemplateRef<any>;
  @Input() valueMapDataList: any[];
  @Input() additionalClassIdMap: Map<string, Set<number>>;
  @Input() additionalRowClass: string;
  @Input() defaultNzWidth = 80;
  @Input() setOfCheckedId = new Set<any>();
  @Input() dragDropSupport = false;
  @Input() primaryKey = 'id';
  @Input() showTableConfig = true;

  @Input() nzVirtualItemSize = 38;
  @Input() nzVirtualMinBufferPx = 600;
  @Input() nzVirtualMaxBufferPx = 1200;

  @Output() onMouseMoveOn = new EventEmitter();
  @Output() onMouseMoveOut = new EventEmitter();
  @Output() onMouseUpOnItem = new EventEmitter();
  @Output() onRowClicked = new EventEmitter();
  @Output() toggleAllClicked = new EventEmitter();
  @Output() toggleItemClicked = new EventEmitter();

  @Output() onCellEditStart = new EventEmitter();
  @Output() onCellEditEnd = new EventEmitter();
  @Output() expandStatusChanged = new EventEmitter();
  @Output() rowDataDropped = new EventEmitter();
  @Output() onColumnSettingsSaved = new EventEmitter();
  @Output() onPageIndexChanged = new EventEmitter();
  @Output() onQueryParamChange = new EventEmitter();
  @Output() pageSizeChange = new EventEmitter<number>();

  @Output() onCellClicked = new EventEmitter();

  valueMapData = {};
  valueSelectMapData = {};
  indeterminate = false;
  showSearcher: boolean = true;
  tempPickedColumnSettings: SysDataModelField[] = [];
  pickList: any[];
  searchText: string = '';
  searchConfig: {};
  dataColumnSettings;
  hasInitialed = false;
  expandSet = new Set<number>();
  tagList: any[] = [];
  tagNameMap: any = {};
  tagCategoryList: any[] = [];
  currentItem: any;
  sortSettingsMap: any = {};
  filterSettingsMap: any = {};
  editId: any | null = null;
  editField: any | null = null;
  processor: any;
  processorSettings: any;
  processorForm: FormGroup;
  fullData: any[] = [];
  displayData: any[] = [];
  defaultSortMap = {};
  defaultFilterMap = {};
  changedFilterMap = {};
  menuItem = {};
  preColumnsFixed = false;
  tableLayout: NzTableLayout = 'auto';
  extraTdFixed: boolean = false;
  currentRow: any;

  constructor(
    private sysDataModelFieldService: SysDataModelFieldService,
    private sysUiDisplayService: SysUiDisplayService,
    private permissionToolkitService: PermissionToolkitService,
    private fb: FormBuilder,
    private tagService: TagService,
    private tagCategoryService: TagCategoryService,
    private modalService: NzModalService,
    private notification: NzNotificationService,
    private contextMenuService: NzContextMenuService,
    private storageService: StorageService,
    private translateService: TranslateService,
    private datePipe: DatePipe
  ) {
    this.buildForm();
    this.sortSettingsMap = {};
    this.filterSettingsMap = {};
  }

  ngOnInit() {
    if (this.useDataProcessor) {
      this.loadScriptProcessorSettings();
    }
  }

  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
    this.expandStatusChanged.emit({id: id, expand: checked});
  }

  async ngOnChanges(changes: SimpleChanges) {
    this.businessType = this.storageService.getBusinessTypeItem();
    if (changes.dataModelId && changes.dataModelId.firstChange) {
      const result = await this.sysDataModelFieldService.getById(this.dataModelId).toPromise();
      // this.columnSettings = result.filter(d => d.isDisplayField);
      this.columnSettings = result; // 不过滤 完全手动去选择
      const dataColumnConfigs = await this.sysUiDisplayService
        .getConfigData(this.businessType, this.dataModelId, this.configType, this.pageName, this.pageCode).toPromise();
      if (dataColumnConfigs && dataColumnConfigs.length > 0) {
        dataColumnConfigs.sort((a, b) => moment(b.updateTime).valueOf() - moment(a.updateTime).valueOf()); // 取最新更新的那条
        this.dataColumnSettings = dataColumnConfigs[0];
        this.pickedColumnSettings = JSON.parse(this.dataColumnSettings.configContent);
        if (this.pickedColumnSettings) {
          const selectedIds = this.pickedColumnSettings.map(field => field.id);
          this.columnSettings = this.columnSettings.filter(c => selectedIds.indexOf(c.id) === -1);
        }
      } else {
        this.dataColumnSettings = null;
        this.pickedColumnSettings = [];
      }
      this.pickedColumnSettings.forEach(column => {
        this.sortSettingsMap[column.id] = {
          sortOrder: null,
          sortFn: true
        };
        this.filterSettingsMap[column.id] = {
          filterOfCategory: [],
          filterCategoryFn: true
        };
      });
      this.columnSettings.sort((a, b) => a.displayOrder - b.displayOrder);
      this.pickList = this.columnSettings;
      this.buildFieldSearchConfig();
    }

    if (this.columnSettings && this.pickedColumnSettings && !this.dataModelId) {
      // this.columnPickable = false;
      // this.pickedColumnSettings = this.columnSettings;
      if (this.pickedColumnSettings) {
        this.pickedColumnSettings.forEach(column => {
          this.sortSettingsMap[column.id] = {
            sortOrder: null,
            sortFn: true
          };
          this.filterSettingsMap[column.id] = {
            filterOfCategory: [],
            filterCategoryFn: true
          };
        });

        const selectedIds = this.pickedColumnSettings.filter(c => c.displayed).map(field => field.id);
        this.columnSettings = this.columnSettings.filter(c => selectedIds.indexOf(c.id) === -1);
      }
      this.pickList = this.columnSettings;
      this.buildFieldSearchConfig();
    }

    if(changes.pickedColumnSettings && changes.pickedColumnSettings.firstChange) {
      if (this.pickedColumnSettings) {
        const isDataEllipsis = this.pickedColumnSettings.some(settings => settings.dataEllipsis);
        if (isDataEllipsis) {
          this.tableLayout = 'fixed';
        } else {
          this.tableLayout = 'auto';
        }
      }
    }

    if (changes.valueMapDataList) {
      this.valueMapData = {};
      if (this.valueMapDataList) {
        this.valueMapDataList.forEach(d => {
          this.valueMapData[d.id] = d.mapData;
          d.selectList = [];
          for (const data in d.mapData) {
            d.selectList.push({name: d.mapData[data], id: typeof data === 'string' ? data : parseInt(data, 10)});
          }
          this.valueSelectMapData[d.id] = d.selectList;
        });
      }

      // console.log('这是配置',this.valueMapData)
    }

    if (changes.setOfCheckedId) {
      this.refreshCheckedStatus();
    }

    if (changes.tagCategory && changes.tagCategory.firstChange) {
      // 只使用没有禁用的标签
      if (this.tagCategory) {
        if (typeof this.tagCategory === 'string') {
          this.tagList = await this.tagService.searchData({tagCategoryCode: this.tagCategory, disabled: false}, true, 3000).toPromise();
        } else {
          const res = await this.tagService.cachedFullData.toPromise();
          this.tagList = res.filter(t => this.tagCategory.includes(t.tagCategoryCode) && !t.disabled);
        }

        // 非聚合标签显示
        if (!this.aggregateTag) {
          const tagSettings = [];
          this.tagList.forEach(t => {
            tagSettings.push({
              id: t.id,
              fieldDisplayName: t.tagName,
              fieldDataType: 'Tag'
            });
          });
          this.pickList = this.pickList.concat(tagSettings);
        }

        // 聚合标签显示
        if (this.aggregateTag) {
          if (typeof this.tagCategory === 'string') {
            this.tagCategoryList = await this.tagCategoryService.searchData({tagCategoryCode: this.tagCategory, displayed: true}, true, 3000).toPromise();
          } else {
            const res = await this.tagCategoryService.cachedFullData.toPromise();
            this.tagCategoryList = res.filter(t => this.tagCategory.includes(t.tagCategoryCode) && t.displayed);
          }

          this.tagNameMap = {};
          this.tagList.forEach(t => {
            this.tagNameMap[t.id] = t.tagName;
          });

          const tagCategorySettings = [];
          this.tagCategoryList.forEach(t => {
            tagCategorySettings.push({
              id: t.id,
              fieldDisplayName: t.tagCategoryName,
              fieldDataType: 'aggregateTag'
            });
          });

          this.pickList = this.pickList.concat(tagCategorySettings);

        }

      }
    }

    if (changes.data) {
      // if (this.useDataProcessor) {
      //   if (changes.data.firstChange) {
      //     await this.loadScriptProcessorSettings();
      //   }
      // }
      // this.checkFilterStatus();
      this.buildFieldConfig();
      this.runDataProcessor();
      this.applyCustomFilter();
    }

    // 如果不用脚本处理  就不显示按钮
    if (!this.useDataProcessor) {
      this.showDataProcessorBtn = false;
    }

    if (changes.defaultCheckAll) {
      if (this.defaultCheckAll) {
        this.onAllChecked(true);
      }
    }

    this.processToolBtnPrivilege();
    this.processIndexColumnFixStatus();
    this.checkExtraColumnFix();
  }

//   ngDoCheck(){
//     let dom = document.getElementsByClassName("cdk-virtual-scroll-orientation-vertical")[0];
//     if (dom) {
//       if (dom.clientHeight == dom.scrollHeight) {
//         let d:any = document.getElementsByClassName("nz-table-hide-scrollbar")[0];
//         if (d) {
//           d["style"]["overflow"]= "hidden";
//         }
//       } else if (dom.clientHeight < dom.scrollHeight) {
//         let d:any = document.getElementsByClassName("nz-table-hide-scrollbar")[0];
//         if (d) {
//           d["style"]["overflow"]= "hidden scroll";
//           d["style"]["overflow-x"]= "hidden";
//           d["style"]["overflow-y"]= "scroll";
//         }
//       }
//     }
//   }

  processToolBtnPrivilege() {
    if (this.privilegeControl && this.toolBtnPrivilegeCode) {
      const hasPrivilege = this.permissionToolkitService.hasPagePermission(this.toolBtnPrivilegeCode);
      this.showToolBtn = hasPrivilege;
    }
  }

  async loadScriptProcessorSettings() {
    const processorSettings = await this.sysUiDisplayService
      .getConfigData(this.businessType, this.dataModelId, 'scriptPsr', this.dataModelId, this.pageCode).toPromise();
    if (processorSettings.length > 0) {
      this.processorSettings = processorSettings[0];
    }
    if (this.processorSettings) {
      this.processor = JSON.parse(this.processorSettings.configContent);
    } else {
      this.processor = null;
    }
  }

  canSetFixLeft(currentIndex) {
    if (currentIndex === 0) {
      return true;
    } else if (this.tempPickedColumnSettings[currentIndex - 1] && this.tempPickedColumnSettings[currentIndex - 1].nzLeft === true) {
      return true;
    } else {
      return false;
    }
  }

  canSetFixRight(currentIndex) {
    if (currentIndex === this.tempPickedColumnSettings.length - 1) {
      return true;
    } else if (this.tempPickedColumnSettings[currentIndex + 1] && this.tempPickedColumnSettings[currentIndex + 1].nzRight === true) {
      return true;
    } else {
      return false;
    }
  }

  checkExtraColumnFix() {
    if (this.setExtraTdFixed) {
      this.extraTdFixed = true;
      return;
    }
    if (this.pickedColumnSettings) {
      const isSetFixRight = this.pickedColumnSettings.some(column => column.nzRight === true);
      if (isSetFixRight) {
        this.extraTdFixed = true;
      }
    }
  }

  sortPredicate(index: number, item: CdkDrag) {
    return index > item.data.leftFixedIndex && index < item.data.rightFixedIndex;
  }

  getFixedColumnIndex() {
    let leftResult = 0, rightResult = this.tempPickedColumnSettings.length - 1;
    for (let i = this.tempPickedColumnSettings.length; i > 0; i--) {
      const item = this.tempPickedColumnSettings[i];
      if (item && item.nzLeft) {
        leftResult = i;
        break;
      }
    }
    for (let i = 0; i < this.tempPickedColumnSettings.length; i++) {
      const item = this.tempPickedColumnSettings[i];
      if (item && item.nzRight) {
        rightResult = i;
        break;
      }
    }
    return {
      leftFixedIndex: leftResult,
      rightFixedIndex: rightResult,
    };
  }

  canChangeFixLeft(currentIndex) {
    if (this.tempPickedColumnSettings[currentIndex + 1] && this.tempPickedColumnSettings[currentIndex + 1].nzLeft === true) {
      return false;
    } else {
      return true;
    }
  }

  canChangeFixRight(currentIndex) {
    if (this.tempPickedColumnSettings[currentIndex - 1] && this.tempPickedColumnSettings[currentIndex - 1].nzRight === true) {
      return false;
    } else {
      return true;
    }
  }

  buildForm() {
    this.processorForm = this.fb.group({
      useDataScript: [false],
      script: [`rowData => {}`]
    });
  }

  checkScriptValidator() {
    if (this.processor && this.processor.useDataScript) {
      this.processorForm.get('script').setValidators(Validators.required);
    } else {
      this.processorForm.get('script').setValidators(null);
    }
  }

  confirmScriptProcessorSettings(processorSettings) {
    if (this.processorSettings && this.processorSettings.id) {
      this.processorSettings.configContent = JSON.stringify(processorSettings)
    } else {
      this.processorSettings = {
        businessType: this.businessType,
        dataModelId: this.dataModelId,
        configContent: JSON.stringify(processorSettings),
        configType: 'scriptPsr',
        pageName: this.dataModelId,
        pageCode: this.pageCode
      }
    }
    return this.sysUiDisplayService.save(this.processorSettings);
  }
  resetProcessor() {
    this.buildForm();
    this.processor = this.processorForm.getRawValue();
  }
  handleCancel() {
    this.dataProcessorModal.destroy();
  }
  async handleOk() {
    for (const i in this.processorForm.controls) {
      this.processorForm.controls[i].markAsTouched();
      this.processorForm.controls[i].updateValueAndValidity();
    }
    if (this.processorForm.valid) {
      try {
        this.isLoading = true;
        const saveData = _.cloneDeep(this.processor);
        const result = await this.confirmScriptProcessorSettings(saveData).toPromise();
        this.notification.success(this.translateService.instant('数据处理脚本设置已保存'), '');
        await this.loadScriptProcessorSettings();
        this.runDataProcessor();
        this.isLoading = false;
        this.dataProcessorModal.destroy();
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    }
  }

  buildFieldSearchConfig() {
    this.searchConfig = {};
    if (this.pickedColumnSettings) {
      const fieldProperties = this.pickedColumnSettings.filter(column =>
        !this.stringEqual('Tag', column.fieldDataType) && column.fieldPropertyName && column.searchAble);
      if (fieldProperties.length === 0) {
        this.searchConfig['id'] = this.searchText || '';
      } else {
        fieldProperties.forEach(column => {
          this.searchConfig[column.fieldPropertyName] = this.searchText || '';
        });
      }
    } else {
      this.searchConfig['id'] = this.searchText || '';
    }
  }

  buildFieldConfig() {
    if (this.pickedColumnSettings) {

      // 排序相关
      const sortAbleSettings = this.pickedColumnSettings.filter(column => column.sortAble);
      sortAbleSettings.forEach(column => {
        const sortFn: NzTableSortFn = (a, b) => {
          try {
            if (!a[column.fieldPropertyName]) {
              return 1
            } else {
              if (!b[column.fieldPropertyName]) {
                return -1
              } else {
                if (typeof a[column.fieldPropertyName] === 'number' &&
                  typeof b[column.fieldPropertyName] === 'number' ) {
                  return a[column.fieldPropertyName] - b[column.fieldPropertyName];
                } else {
                  return a[column.fieldPropertyName].localeCompare(b[column.fieldPropertyName]);
                }
              }
            }
          } catch (e) {
            return -1;
          }
        }
        this.sortSettingsMap[column.id] = {
          sortOrder: this.defaultSortMap[column.id] || null,
          sortFn: sortFn
        };
      });

      // 过滤相关
      const filterAbleSettings = this.pickedColumnSettings.filter(column => column.filterAble);
      filterAbleSettings.forEach(column => {
        const filterValues = Array.from(new Set(this.data.map(d => d[column.fieldPropertyName])));
        const filterCategory: { text: string; label: string; value: any; byDefault?: boolean; checked?: boolean; }[] = [];
        if (!this.defaultFilterMap[column.id]) {
          this.defaultFilterMap[column.id] = [];
        }
        filterValues.sort().forEach(v => {
          let filterObj;
          if (this.valueMapData[column.valueMapData]) {
            filterObj = {
              value: v,
              text: column.valueMapData ? this.valueMapData[column.valueMapData][v] : v,
              label: this.getFieldLabel(v, column),
              byDefault: this.defaultFilterMap[column.id].indexOf(v) > -1,
              checked: this.defaultFilterMap[column.id].indexOf(v) > -1
            }
          } else {
            filterObj = {
              value: v,
              text: v,
              label: this.getFieldLabel(v, column),
              byDefault: this.defaultFilterMap[column.id].indexOf(v) > -1,
              checked: this.defaultFilterMap[column.id].indexOf(v) > -1
            }
          }

          filterCategory.push(filterObj);
        });

        const filterFn: NzTableFilterFn = (content: string, item: any) => content.indexOf(item[column.fieldPropertyName]) > -1;
        // @ts-ignore
        this.filterSettingsMap[column.id] = {
          filterOfCategory: filterCategory,
          hasFilterSet: filterCategory.some(d => d.checked),
          filterCategoryFn: filterFn
        };
      });

      // 表格编辑相关
      const editAbleSettings = this.pickedColumnSettings.filter(column => column.editAble);
      editAbleSettings.forEach(column => {
        // const filterValues = Array.from(new Set(this.displayData.map(d => d[column.fieldPropertyName])));
        // const filterCategory: NzTableFilterList = [];
        // filterValues.sort().forEach(v => {
        //   filterCategory.push({
        //     value: v,
        //     text: column.valueMapData ? this.valueMapData[column.valueMapData][v] : v
        //   });
        // });
        //
        // const filterFn: NzTableFilterFn = (content: string, item: any) => content.indexOf(item[column.fieldPropertyName]) > -1;
        // this.filterSettingsMap[column.id] = {
        //   filterOfCategory: filterCategory,
        //   filterCategoryFn: filterFn
        // };
      });

      this.hasInitialed = true;
    }

    // console.log(this.sortSettingsMap);
    // console.log(this.filterSettingsMap);
  }

  getFieldLabel(value, column) {
    if (column.valueMapData) {
      return this.valueMapData[column.valueMapData][value];
    } else {
      if ('Date' === column.fieldDataType) {
        return moment(value).format('YYYY-MM-DD');
      } else if ('DateTime' === column.fieldDataType) {
        return this.datePipe.transform(value, column.dataFormat || 'yyyy-MM-dd HH:mm');
      } else {
        return value;
      }
    }
  }

  selectAllFilterItem(categoryItems: any[]) {
    if (categoryItems) {
      categoryItems.forEach(item => item.checked = true);
    }
  }
  reverseSelectFilterItems(categoryItems: any[]) {
    if (categoryItems) {
      categoryItems.forEach(item => item.checked = !item.checked);
    }
  }

  updateCheckStatus(column, $event) {
    this.filterSettingsMap[column.id].filterOfCategory = $event;
    this.defaultFilterMap[column.id] = $event.filter(d => d.checked).map(d => d.value);
  }

  applyCustomFilter(targetColumn?) {
    if (this.fullData) {
      this.displayData = [... this.fullData];
    }
    if (this.pickedColumnSettings) {
      // 过滤相关
      const filterAbleSettings = this.pickedColumnSettings.filter(column => column.filterAble);
      filterAbleSettings.forEach(column => {
        this.filterSettingsMap[column.id].hasFilterSet =
          this.filterSettingsMap[column.id].filterOfCategory.some(d => d.checked);
        if (this.filterSettingsMap[column.id].hasFilterSet) {
          const checkedValues = this.filterSettingsMap[column.id].filterOfCategory.filter(d => d.checked).map(d => d.value);
          this.displayData = this.displayData.filter(d => {
            return checkedValues.indexOf(d[column.fieldPropertyName]) > -1;
          });
        }
      });
      this.displayData = [... this.displayData];
    }
    if (targetColumn) {
      targetColumn.filterVisible = false;
    }
  }

  resetCustomFilter(column) {
    this.defaultFilterMap[column.id] = [];
    this.filterSettingsMap[column.id].hasFilterSet = false;
    this.filterSettingsMap[column.id].filterOfCategory.forEach(c => c.checked = false);
    this.applyCustomFilter();
    column.filterVisible = false;
  }

  checkFilterStatus() {
    if (this.pickedColumnSettings && this.data) {
      const filterAbleSettings = this.pickedColumnSettings.filter(column => column.filterAble);
      filterAbleSettings.forEach(column => {
        const filterValues = Array.from(new Set(this.data.map(d => d[column.fieldPropertyName])));

        if (this.changedFilterMap[column.id]) { // 如果手动调整过，使用调整过的值
          this.defaultFilterMap[column.id] = this.changedFilterMap[column.id];
        } else { // 没调整过的，使用全选效果
          // this.defaultFilterMap[column.id] = filterValues;
          this.defaultFilterMap[column.id] = [];
        }
      });
    }
  }

  checkSort(columnId, $event) {
    this.defaultSortMap[columnId] = $event;
  }
  // checkFilter(columnId, $event) {
  //   this.defaultFilterMap[columnId] = $event;
  //   this.changedFilterMap[columnId] = $event;
  // }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }

  cdkDropEvent(event: CdkDragDrop<any[]>) {
    this.rowDataDropped.emit(event);
  }

  async confirmColumnSelection(pickedColumnSettings) {
    if (this.dataColumnSettings) {
      this.dataColumnSettings.configContent = JSON.stringify(pickedColumnSettings)
    } else {
      this.dataColumnSettings = {
        businessType: this.businessType,
        dataModelId: this.dataModelId,
        configContent: JSON.stringify(pickedColumnSettings),
        configType: this.configType,
        pageCode: this.pageCode
      }
    }
    return this.sysUiDisplayService.save(this.dataColumnSettings).toPromise();
  }

  showColumnConfiguration() {
    this.tempPickedColumnSettings = _.cloneDeep(this.pickedColumnSettings);
    this.modalService.create({
      nzTitle: this.translateService.instant('表格字段显示设置'),
      nzContent: this.columnSettingsTpl,
      nzWidth: this.columnPickable ? 1200 : 800,
      nzOnOk: async () => {
        try {
          if (this.dataModelId) {
            const result = await this.confirmColumnSelection(this.tempPickedColumnSettings);
            if (result['data']) {
              this.pickedColumnSettings = this.tempPickedColumnSettings;
            }
          } else {
            this.onColumnSettingsSaved.emit(this.tempPickedColumnSettings);
            this.pickedColumnSettings = this.tempPickedColumnSettings;
          }

          this.buildFieldSearchConfig();
          this.buildFieldConfig();
          this.processIndexColumnFixStatus();
          this.checkExtraColumnFix();
          return true;
        } catch (e) {
          console.log(e);
          return false;
        }
      }
    })
  }

  processIndexColumnFixStatus() {
    if ((this.showIndexCount || this.selectable || this.showExpand) && this.pickedColumnSettings && this.pickedColumnSettings[0] && this.pickedColumnSettings[0].nzLeft) {
      this.preColumnsFixed = true;
    } else {
      this.preColumnsFixed = false;
    }
  }

  showDataProcessorModal() {
    if (!this.processor) {
      this.processor = this.processorForm.getRawValue();
    }

    this.dataProcessorModal = this.modalService.create({
      nzTitle: this.translateService.instant('数据处理脚本设置'),
      nzContent: this.dataProcessorContent,
      nzWidth: 500,
      nzFooter: this.dataProcessorFooter
    })
  }

  runDataProcessor() {
    if (this.data) {
      this.displayData = _.cloneDeep(this.data);
      if (this.processor && this.processor.useDataScript) {
        const processorFn = eval(this.processor.script);
        if (this.displayData) {
          for (let i = 0; i < this.displayData.length; i++) {
            const rowData = this.displayData[i];
            try {
              processorFn(rowData);
            } catch (e) {
              console.log(e);
              continue;
            }
          }
        }
      }
      if (this.displayData) {
        this.fullData = this.displayData;
        this.displayData = [... this.displayData];
      }
    }
  }

  // trackByIndex(_: number, data: any): number {
  //   return this.getDataPrimaryKey(data);
  // }

  trackByIndex(_: number, data: any): number {
    return data.id;
  }

  getDataPrimaryKey(data) {
    return data[this.primaryKey];
  }

  exportCurrentData() {
    const fileName = this.exportFileName + '_' + moment().format('YYYYMMDD-HH:mm');
    var workbook = XLSX.utils.book_new();
    const exportData = this.generateCSVDataFlight();
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    if (exportData.length) {
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, fileName);
    } else {
      this.notification.error(this.translateService.instant('无可用数据导出'), '');
    }
  }

  generateCSVDataFlight() {
    // const data = this.displayData;
    const data = this.mainTable.data;
    const rowData = [];

    data.forEach((d, index) => {
      let obj = {};


      this.pickedColumnSettings.forEach(columnSetting => {
        let value;
        if (columnSetting.dataFormat) { // angular的日期格式与moment不同，需要特殊处理
          columnSetting.outputDataFormat = columnSetting.dataFormat.replace(/y/g, 'Y');
          columnSetting.outputDataFormat = columnSetting.dataFormat.replace(/d/g, 'D');
        }
        if (this.stringEqual('Date', columnSetting.fieldDataType)) {
          if (d[columnSetting.fieldPropertyName]) {
            value = moment(d[columnSetting.fieldPropertyName])
              .format(columnSetting.outputDataFormat ? columnSetting.outputDataFormat : 'YYYY-MM-DD');
          } else {
            value = '';
          }
        } else if (this.stringEqual('DateTime', columnSetting.fieldDataType)) {
          if (d[columnSetting.fieldPropertyName]) {
            value = moment(d[columnSetting.fieldPropertyName])
              .format(columnSetting.outputDataFormat ? columnSetting.outputDataFormat : 'YYYY-MM-DD HH:mm');
          } else {
            value = '';
          }
        } else if (this.stringEqual('Tag', columnSetting.fieldDataType)) {
          if (d['tagIds'] && d['tagIds'].indexOf(columnSetting.id) > -1) {
            value = this.translateService.instant('是');
          }
        }  else if (this.stringEqual('Progress', columnSetting.fieldDataType)) {
          value = d[columnSetting.fieldPropertyName] + '%';
        } else {//如果可以转为对应值的话
          value = this.valueMapData[columnSetting.valueMapData]? this.valueMapData[columnSetting.valueMapData][d[columnSetting.fieldPropertyName]]:d[columnSetting.fieldPropertyName];
        }

        if (columnSetting['alias'] && columnSetting['alias'] !== '') {
          obj[columnSetting['alias']] = value;
        } else {
          obj[columnSetting.fieldDisplayName] = value;
        }
      });

      rowData.push(obj);
    });
    return rowData;
  }

  saveAsExcelFile(buffer: any, fileName: string) {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    FileSaver.saveAs(data, fileName + '.xlsx'); // 如果写成.xlsx,可能不能打开下载的文件，这可能与Excel版本有关
  }

  moveOnItem(item, $event) {
    this.currentItem = item;
    this.onMouseMoveOn.emit(item);
  }
  moveOutItem(item, $event) {
    this.currentItem = null;
    this.onMouseMoveOut.emit(item);
  }
  mouseUpOnItem(item, $event) {
    this.currentItem = item;
    this.onMouseUpOnItem.emit(item);
  }

  updateCheckedSet(id: any, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
    this.toggleItemClicked.emit(this.getCheckedData());
  }

  onItemChecked(id: any, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    if (this.displayData && this.displayData.length > 0) {
      this.allChecked = this.displayData.every(item => this.setOfCheckedId.has(this.getDataPrimaryKey(item)));
      this.indeterminate = this.displayData.some(item => this.setOfCheckedId.has(this.getDataPrimaryKey(item))) && !this.allChecked;
    } else {
      this.allChecked = false;
      this.indeterminate = false;
    }
  }

  onAllChecked(checked: boolean): void {
    if (this.displayData) {
      this.displayData.forEach(item => this.updateCheckedSet(this.getDataPrimaryKey(item), checked));
      this.refreshCheckedStatus();
      this.toggleAllClicked.emit(this.getCheckedData());
    }
  }

  public getCheckedData() {
    return this.getFiltedDispalyData().filter(item => this.setOfCheckedId.has(this.getDataPrimaryKey(item)));
  }

  public getCurrentData() {
    return this.currentRow;
  }

  getTableDisplayDataNum() {
    return this.mainTable ? this.mainTable.data.length : 0;
  }
  getFiltedDispalyData() {
    const displayData = this.mainTable.data.filter(item => this.setOfCheckedId.has(this.getDataPrimaryKey(item)));
    return displayData;
  }

  public getDisplayData() {
    return this.displayData;
  }

  stringEqual(a: string, b: string) {
    if (a && b) {
      return a.toLowerCase() === b.toLowerCase();
    } else {
      return a === b;
    }
  }

  isIdIncluded(id, set) {
    return set.has(id);
  }

  additionalClassSettings(flightId) {
    const result = {};
    if (this.additionalClassIdMap) {
      for (let className in this.additionalClassIdMap) {
        if (this.additionalClassIdMap[className]) {
          result[className] = this.isIdIncluded(flightId, this.additionalClassIdMap[className])
        }
      }
    }
    if (this.additionalRowClass) {
      result[this.additionalRowClass] = true;
    }
    return result;
  }

  public scrollToIndex(index: number) {
    this.mainTable?.cdkVirtualScrollViewport?.scrollToIndex(index);
  }

  startEdit(id, field): void {
    this.editId = id;
    this.editField = field;
    this.onCellEditStart.emit({id: id, field: field});
  }

  stopEdit(data): void {
    this.onCellEditEnd.emit(data);
    this.editId = null;
    this.editField = null;
  }

  getTableWidth() {
    let tableWidth = (this.selectableNzWidth * (this.selectable ? 1 : 0)) + (this.showExpandNzWidth * (this.showExpand ? 1 : 0)) + this.extraTdWidth + this.indexCountNzWidth;
    if (this.pickedColumnSettings) {
      this.pickedColumnSettings.forEach(column => {
        tableWidth += (!!column.nzWidth ? (typeof column.nzWidth === 'number' ? column.nzWidth : this.defaultNzWidth) : this.defaultNzWidth)
      })
    }
    return tableWidth;
  }

  @HostListener('document:keydown.escape', ['$event'])
  cancellAll(event: KeyboardEvent) {
    this.editId = null;
    this.editField = null;
  }

  contextMenu($event: MouseEvent, menu: NzDropdownMenuComponent, currentItem): void {
    if (this.showPopupMenu) {
      this.menuItem = currentItem;
      this.contextMenuService.create($event, menu);
    }
  }

  rowClick(item) {
    this.currentRow = item;
    this.onRowClicked.emit(item);
  }

  getCurrentRowStyle(item) {
    if (!this.currentRow) {
      return '';
    } else {
      return this.getDataPrimaryKey(item) === this.getDataPrimaryKey(this.currentRow) ? 'currentRow' : '';
    }
  }

  onPageChange(index: number) {
    this.onPageIndexChanged.emit(index);
  }

  queryParamChange(index: number) {
    this.onQueryParamChange.emit(index);
  }
}
